import { render, staticRenderFns } from "./Ripple.vue?vue&type=template&id=a5a39f24&scoped=true"
import script from "./Ripple.vue?vue&type=script&lang=js"
export * from "./Ripple.vue?vue&type=script&lang=js"
import style0 from "./Ripple.vue?vue&type=style&index=0&id=a5a39f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a39f24",
  null
  
)

export default component.exports